export enum LangueEnum {
    'FR', 'DE', 'EN', 'ES','PT', 'Autre'

}
